import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: { "Content-Type": "application/json" },
});

// Read token fresh on every request — fixes "Invalid authentication principal"
// when token is set after module load
api.interceptors.request.use((config) => {
  const token = getToken();
  console.debug("[admin_api] request:", config.method?.toUpperCase(), config.url);
  console.debug("[admin_api] token present:", !!token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("[admin_api] No token found — request will be unauthenticated");
  }
  return config;
});

api.interceptors.response.use(
  (response) => {
    console.debug("[admin_api] response:", response.status, response.config.url);
    return response;
  },
  (error) => {
    const status = error?.response?.status;
    const url    = error?.config?.url;
    const msg    = error?.response?.data?.message || error?.response?.data;
    console.error(`[admin_api] error ${status} on ${url}:`, msg);
    if (status === 401) {
      console.warn("[admin_api] 401 — token may be missing, expired, or wrong type (need ADMIN token)");
    }
    return Promise.reject(error);
  }
);

export default api;
